module.exports = "https://r.nearpod.com/assets/media/image/interactive-video-16b55ddf05ee10d65b8a1010dbf2f9f1.svg";